import {
  SET_MYTRIPS_RESULTS,
  CLEAR_MYTRIPS_RESULTS,
  FILTER_TRIPS,
  SELECT_TRIP,
  UPDATE_TRIPNAME,
  UPDATE_MYTRIPS_RESULTS,
  SET_DUTY_OF_CARE,
  SET_MYTRIPS_COUNT,
  SET_REBOOK_PASSENGERS,
  UNCHECK_REBOOK_PASSENGERS,
  CHECK_REBOOK_PASSENGERS,
  SET_MESSAGES,
  SET_LOADING,
} from '../actions/mytrips';

const initialState = {
  myTripsResults: null,
  isAnyFilterApplied: false,
  tripSelected: null,
  loadingState: { isLoading: false, message: '' },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_MYTRIPS_RESULTS:
      return {
        ...state,
        myTripsResults: action.myTrips,
      };
    case SET_MYTRIPS_COUNT:
      return {
        ...state,
        myTripCount: action.myTripsCount,
      };
    case SET_REBOOK_PASSENGERS:
      return {
        ...state,
        rebookPassengers: action.rebookPassengers.RebookPassengerList.map((passenger) => ({
          ...passenger,
          associateTravelerRefNumber: '',
          isCheck: true,
        })),
        passengerTypeArr: action.rebookPassengers.passengerTypeArr,
        adultCount: action.rebookPassengers.AdultCount,
        childrenCount: action.rebookPassengers.ChildrenCount,
        infantCount: action.rebookPassengers.InfantCount,
        infantWithSeatCount: action.rebookPassengers.InfantWithSeatCount,
        seniorsCount: action.rebookPassengers.SeniorsCount,
        youthCount: action.rebookPassengers.YouthCount,
      };
    case CHECK_REBOOK_PASSENGERS:
      return {
        ...state,
        rebookPassengers: state.rebookPassengers.map((passenger) =>
          passenger.IROPPassengerKey === action.checkedPassenger.IROPPassengerKey
            ? { ...passenger, isCheck: true }
            : passenger
        ),
      };

    case UNCHECK_REBOOK_PASSENGERS:
      return {
        ...state,
        rebookPassengers: state.rebookPassengers.map((passenger) =>
          passenger.IROPPassengerKey === action.checkedPassenger.IROPPassengerKey
            ? { ...passenger, isCheck: false }
            : passenger
        ),
      };

    case UPDATE_MYTRIPS_RESULTS:
      return {
        ...state,
        myTripsResults: {
          ...state.myTripsResults,
          myCrowd: state.myTripsResults.myCrowd
            .concat(action.myTrips.myCrowd)
            .filter((v, i, s) => s.findIndex((e) => e.TripKey === s[i].TripKey) === i),
        },
      };
    case CLEAR_MYTRIPS_RESULTS:
      return {
        ...state,
        myTripsResults: {
          ...state.myTripsResults,
          myCrowd: [],
        },
      };
    case FILTER_TRIPS:
      return {
        ...state,
        myTripsResults: {
          ...state.myTripsResults,
          destinationForFilter: action.tripsFilters,
        },
        isAnyFilterApplied: action.isAnyFilterApplied,
      };
    case SELECT_TRIP:
      return {
        ...state,
        tripSelected: action.tripSelected,
      };
    case UPDATE_TRIPNAME: {
      return {
        ...state,
        myTripsResults: {
          ...state.myTripsResults,
          myCrowd: state.myTripsResults.myCrowd.map((trips, index) =>
            index === action.tripIndex ? { ...trips, TripName: action.tripName } : trips
          ),
        },
        tripSelected: {
          ...state.tripSelected,
          TripName: action.tripName,
        },
      };
    }
    case SET_DUTY_OF_CARE:
      return {
        ...state,
        lastCheckedDate: action.lastDate,
      };
    case SET_MESSAGES:
      return {
        ...state,
        messages: action.messages,
      };
    case SET_LOADING:
      return {
        ...state,
        loadingState: action.loading,
      };
    default:
      return state;
  }
};
